import { connect } from 'react-redux'
import Globals from '../../../globals'
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import CustomerContact from '../detail/CustomerContact'
import { selectCanSeeImages } from '../../../security/state/auth/selector'
import { callNumber } from '../../../sipgate/state/action'
import { COUNTRY_CODE_LIST, LANGUAGE_LIST } from '../../../internationalization/const'

const mapStateToProps = (state, props) => {
    return {
        contact: selector.selectCustomerContact(state),
        error: selector.selectCustomerError(state),
        salutationList: Globals.selector.selectSalutationList(state),
        canSeeImages: selectCanSeeImages(state),
        countryCodeList: COUNTRY_CODE_LIST,
        languageList: LANGUAGE_LIST,
    }
}

const mapDispatchToProps = {
    callNumber,
    changeCustomerContact: action.changeCustomerContact,
    saveCustomerContact: action.saveCustomerContact,
    hydrateContact: action.hydrateCustomerContact
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerContact)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/CustomerContactWidgetContainer.js